<template>
  <div>
    <v-col class="container3">
      <h1
        class="mt-16"
        style="color: var(--color-text)"
      >
        {{ message }}
      </h1>
      <div class="mt-10">
        <img
          src="./../../../../../assets/no_routes.png"
          height="400px"
          width="400px"
        >
      </div>
    </v-col>
  </div>
</template>

<script>
export default {
  name: "EnptyAreas",
  props: {
    message: String,
  },
};
</script>

    <style scoped>
.container3 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
